import React, { useRef } from 'react'
import './SideNav.css'
import { Button } from 'primereact/button';
import { TieredMenu } from 'primereact/tieredmenu';
import { Toast } from 'primereact/toast';
import { MenuPages } from './MenuConstants.tsx';

export function SideNav() {
  const menuLeft = useRef(null);
  const toast = useRef(null);
  const items = [
    {
      label: 'Math Facts Worksheet Generator',
      icon: 'pi pi-file',
      command:()=>{ window.location.pathname =""; }
    },
    {
        label: MenuPages.Counting,
        icon: 'fa-solid fa-hashtag',
        items: [
          {
              label: 'One Hundred Chart',
              command:()=>{ window.location.pathname ="/counting/onehundredchart"; }
          }        
        ]
    },
    {
        label: MenuPages.Addition,
        icon: 'pi pi-plus',
        items: [
          {
              label: 'Addition Math Facts Worksheet Generator',
              command:()=>{ window.location.pathname ="addition/mathfactsgenerator"; }
          },
          {
            label: 'Addition Word Problem Worksheet Generator',
            command:()=>{ window.location.pathname ="addition/wordproblemgenerator"; }
          }       
        ]
    },
    {
        label: MenuPages.Subtraction,
        icon: 'fa-solid fa-minus',
        items: [
          {
            label: 'Subtraction Worksheet Generator',
            command:()=>{ window.location.pathname ="subtraction/mathfactsgenerator"; }
          },
          {
            label: 'Subtraction Word Problem Worksheet Generator',
            command:()=>{ window.location.pathname ="subtraction/wordproblemgenerator"; }
          }           
        ]
    },
    {
        label: MenuPages.Multiplication,
        icon: 'pi pi-times',
        items: [
          {
            label: 'Multiplication Worksheet Generator',
            command:()=>{ window.location.pathname ="/multiplication-worksheets"; }
          },
          {
            label: 'Multiplication Word Problem Worksheet Generator',
            command:()=>{ window.location.pathname ="multiplication/wordproblemgenerator"; }
          },
          {
            label: 'Multiplication Chart',
            command:()=>{ window.location.pathname ="multiplication/multiplicationChart"; }
          }           
        ]
    },
    {
        label: MenuPages.Division,
        icon: 'fa-solid fa-divide',
        items: [
          {
            label: 'Division Worksheet Generator',
            command:()=>{ window.location.pathname ="division/mathfactsgenerator"; }
          },
          {
            label: 'Long Division Worksheet Generator',
            command:()=>{ window.location.pathname ="division/longdivisionmathfactsgenerator"; }
          },
          {
            label: 'Division Word Problem Worksheet Generator',
            command:()=>{ window.location.pathname ="division/wordproblemgenerator"; }
          },
          {
            label: 'Long Division Word Problem Worksheet Generator',
            command:()=>{ window.location.pathname ="division/longdivisionwordproblemgenerator"; }
          }        
        ]
    }
    // {
    //     label: 'Blog', // Add submenu to this one
    //     icon: 'fa-solid fa-blog',
    //     command:()=>{ window.location.pathname ="/blog"; }
    // },
    // {
    //     label: MenuPages.GradeLevel, // Add submenu to this one
    //     icon: 'fa-solid fa-layer-group',
    //     command:()=>{ window.location.pathname ="/GradeLevel"; }
    // }
          
  ];
  return (
    <div className='menuContainer'>
      <Toast ref={toast}></Toast>
      <TieredMenu model={items} popup ref={menuLeft} id="popup_menu_left" />
      <Button label="Menu" icon="pi pi-align-left" className="mr-2" onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup />
    </div>
  )
}